// src/components/SeoHead.js
import React from 'react';
import { Helmet } from 'react-helmet';

const SeoHead = ({ title, description, url, image, structuredData }) => {
  const jsonLd = structuredData
    ? JSON.stringify(structuredData, null, 2)
    : null;

  return (
    <Helmet>
      {/* Basic SEO */}
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}

      {/* Canonical URL */}
      {url && <link rel="canonical" href={url} />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {url && <meta property="og:url" content={url} />}
      <meta
        property="og:image"
        content={image || 'https://stt.aittsservice.online/og-default.jpg'}
      />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && (
        <meta name="twitter:description" content={description} />
      )}
      <meta
        name="twitter:image"
        content={image || 'https://stt.aittsservice.online/og-default.jpg'}
      />

      {/* JSON-LD Structured Data */}
      {jsonLd && (
        <script type="application/ld+json">{jsonLd}</script>
      )}
    </Helmet>
  );
};

export default SeoHead;
